export const SAVE_CONTACT_US_REQUEST = "SAVE_CONTACT_US_REQUEST";
export const SAVE_CONTACT_US_SUCCESS = "SAVE_CONTACT_US_SUCCESS";
export const SAVE_CONTACT_US_FAILURE = "SAVE_CONTACT_US_FAILURE";
